import { BaseModalViewModel } from '../../../../models/base/base-modal-view-model';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MembersDomainModel } from '../../../../domainModels/members-domain-model';
import { ToastService } from '../../../../services/toast-service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ChangeEmailRequest } from '../../../../models/users/requests/change-email-request';
import { switchMap } from 'rxjs/operators';
import { BaseUser } from '../../../../models/base/base-user';
import { CustomError } from '../../../../models/shared/custom-error';
import { MemberRecord } from '../../../../models/users/dto/member-record';
import { Injectable } from '@angular/core';

@Injectable()
export class ChangeMemberEmailModalViewModel extends BaseModalViewModel {
  constructor(
    public router: Router,
    public ngbModal: NgbModal,
    private memberDomainModel: MembersDomainModel,
    private toastService: ToastService
  ) {
    super(router, ngbModal);
  }

  public changeEmailReq$ = of(new ChangeEmailRequest());

  private _member = new BehaviorSubject<MemberRecord | null>(null);
  public readonly member$ = this._member as Observable<MemberRecord>;

  public setMember(m: MemberRecord): void {
    this._member.next(m);
  }

  public formSubmitted(req: ChangeEmailRequest) {
    const lm = $localize`Changing Email`;
    this.member$
      .pipe(
        switchMap(user => {
          if (!!user) {
            this._loadingOpts.addRequest(lm);
            return this.memberDomainModel.forceChangeEmail(req, user?.id);
          } else {
            return of(null);
          }
        })
      )
      .subscribe({
        next: (updatedUser: BaseUser | null) => {
          if (updatedUser) {
            this.toastService.publishSuccessMessage($localize`Success!`, $localize`Email Changed!`);
            this._loadingOpts.removeRequest(lm);
            this.closeWithReturnValue(updatedUser);
          } else {
            this._loadingOpts.removeRequest(lm);
            this.toastService.publishErrorMessage($localize`Error`, $localize`Failed to change email`);
            this.closeModal();
          }
        },
        error: (err: CustomError) => {
          this._loadingOpts.removeRequest(lm);
          this.toastService.publishError(err);
          this.closeModal();
        },
        complete: () => this._loadingOpts.removeRequest(lm)
      });
  }
}
